<template>
  <div class="w-full relative">
    <div class="w-full">
      <img
        src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Cg-img/subscribe%20page.jpg"
        alt="bg"
        class="w-full cust-subscribe-img"
      />
      <!-- <p class="text-black covertext absolute">Partner With Us</p> -->
    </div>
    <div class="">
      <PremiumSubscribe />
    </div>
  </div>
</template>
<script>
import PremiumSubscribe from "./PremiumSubscribe";
export default {
  components: {
    PremiumSubscribe,
  },
  methods: {
    handlevol() {
      const el = document.getElementById("joinvolunteer");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    handledon() {
      const el = document.getElementById("joindonor");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    handlecar() {
      const el = document.getElementById("joincareers");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    handleinter() {
      const el = document.getElementById("internjoin");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    handlepart() {
      const el = document.getElementById("joinpartner");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
  },
};
</script>
